module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-check-fill-44982912.svg";